module.exports = {"id":7,"name":"Kreativ","price":0,"dimensions":{"margin":{"top":10,"right":10,"bottom":10,"left":10}},"sizes":[{"label":"27x20","isCover":true,"photo_cover":true,"placeholderBorderSize":31,"width":55,"height":220,"margin":{"top":10,"right":2,"bottom":10,"left":2},"resolution":300,"midline_front":114,"midline_back":114,"placeholders":[{"left":0,"top":0,"width":55,"height":220}]}]}


//////////////////
// WEBPACK FOOTER
// ./src/config/templates/covers/pro/landscape/dekor_borito.json
// module id = 890
// module chunks = 0